<template>
  <div>
    <div class="m-0 p-0 font-sans text-gray-800">
        <div class="bg-image w-full"  :style="{ backgroundImage: 'url(' + require('@/assets/images/bg.png') + ')' }">
            <!-- 加载中提示 -->
            <div v-if="loading" class="flex flex-col items-center justify-center min-h-screen p-4">
                <i class="fa fa-circle-notch fa-spin text-4xl text-blue-600 mb-4"></i>
                <p class="text-xl font-medium text-gray-700">正在加载数据...</p>
            </div>

            <!-- 错误提示 -->
            <div v-else-if="error" class="flex flex-col items-center justify-center min-h-screen p-4">
                <i class="fa fa-exclamation-circle text-4xl text-red-500 mb-4"></i>
                <p class="text-xl font-medium text-red-600 mb-2">{{ error }}</p>
                <button @click="fetchData()" class="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                    重试
                </button>
            </div>

            <!-- 内容区域 -->
            <div v-else class="container mx-auto px-4 py-8 max-w-md">
                <div class="content-container rounded-2xl p-6 shadow-lg">
                    <!-- 标题 -->
                    <h1 class="text-2xl md:text-3xl font-bold text-center text-blue-800 mb-6 text-fade-in">
                        【江山恒泰报告查询页】
                    </h1>

                    <!-- 3行居中文字 -->
                    <div class="mb-8 space-y-3 text-center text-gray-700">
                        <p class="text-lg text-fade-in delay-100">报告标题【评估报告】</p>
                        <!-- <p class="text-lg text-fade-in delay-200">报告文号：江山恒泰评字【{{ pageData.reportYear }}】</p>
                        <p class="text-lg text-fade-in delay-200">第{{ pageData.reportNo }}号</p> -->
                        <p class="text-lg text-fade-in delay-200">报告文号：江山恒泰评字{{ pageData.reportNo }}</p>
                        <p class="text-lg text-fade-in delay-300">公司名称：{{ pageData.client }}</p>
                    </div>

                    <!-- 居中图片 -->
                    <div class="flex justify-center mb-8">
                        <img 
                            :src="pageData.qrCodeUrl" 
                            alt="官网" 
                            class="rounded-lg shadow-md max-w-full h-auto max-h-48 object-contain transition-transform hover:scale-105"
                            :class="{ 'image-loading': imageLoading }"
                            @load="imageLoading = false"
                        >
                    </div>

                    <!-- 6行居中文字 -->
                    <div class="space-y-2 text-center text-gray-700">
                        <p class="text-base text-fade-in delay-400">资产评估师：</p>
                        <p class="text-base text-fade-in delay-500">{{ pageData.firstAssetAppraisal }}</p>
                        <p class="text-base text-fade-in delay-600">{{ pageData.secondAssetAppraisal }}</p>
                        <p class="text-base text-fade-in delay-700">报告时间：{{ pageData.reportTime }}</p>
                        <p class="text-base text-fade-in delay-800">免责声明:此报告不得用于拆迁补偿，银行贷款抵押，融资租赁，法律诉讼等用</p>
                        <p class="text-base text-fade-in delay-800">北京江山恒泰资产评估有限公司版权所有</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import '../../assets/css/report.css'
export default {
  name: 'ReportPage',
  data() {
    return {
      loading: false,
      error: '',
      imageLoading: true,
      pageData: {
          //reportYear: 2025,
          reportNo: '0000001',
          client: '天光集团',
          firstAssetAppraisal: '资产评估师1',
          secondAssetAppraisal: '资产评估师2',
          reportTime: '2025-09-10 13:20',
      }
    }
  },
  mounted() {
    // 获取URL中的id参数
    // const id = this.$route.params.id
    const id = '8abe1b3f9dc54568875e785798199e2a'
    console.log(id);
    if (!id) {
        this.error = '未找到id参数,请检查url';
        this.loading = false;
        return;
    }
    
    // 根据id获取数据
    this.fetchData(id);
  },
  methods: {
      
      // 调用API获取数据
      async fetchData(id) {
          this.loading = true;
          this.error = '';
          this.imageLoading = true;

          try {
              // 这里替换为实际的API地址
              const apiUrl = `http://api.shijiao8.com/bg/report/getmodel?id=${id}`;
              const response = await fetch(apiUrl);
              
              if (!response.ok) {
                  throw new Error(`HTTP错误：${response.status}`);
              }

              const res = await response.json();
              
              // 处理API返回的数据，映射到页面数据结构
              // 实际项目中请根据API返回格式调整
              this.pageData = res.data[0];

              // 可选：根据数据动态设置背景图
              // this.backgroundImage = `https://picsum.photos/id/${(id % 100) + 10}/1200/1800`;

          } catch (err) {
              this.error = `数据加载失败: ${err.message}`;
              console.error('API请求错误:', err);
              
              // 加载失败时使用默认数据
              this.pageData = {
                  textLine1: '无法获取数据',
                  textLine2: '请检查网络连接',
                  textLine3: '或稍后重试',
                  imageUrl: 'assets/images/erweima.png', // 默认图片
                  imageAlt: '加载失败',
                  detailLine1: '错误信息:',
                  firstAssetAppraisal: err.message,
                  secondAssetAppraisal: '',
                  detailLine4: '建议:',
                  detailLine5: '1. 检查URL中的ID是否正确',
                  detailLine6: '2. 检查网络连接后重试'
              };
          } finally {
              this.loading = false;
          }
      }
    }
}
</script>

<style scoped>

</style>
